/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelDraftId } from '../../models/travel-draft-id';

export interface TravelControllerCreateDraft$Params {
}

export function travelControllerCreateDraft(http: HttpClient, rootUrl: string, params?: TravelControllerCreateDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftId;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerCreateDraft.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelDraftId;
      }>;
    })
  );
}

travelControllerCreateDraft.PATH = '/travel/draft';
